import { SimpleBannerContent } from '@shared/components/simple-banner';

export enum StepInvoiceControls {
  InvoiceNumber = 'CustomerNumber',
  InvoiceDate = 'InvoiceDate',
  InvoiceType = 'InvoiceType',
  InvoiceCheckbox = 'InvoiceCheckbox',
  DocumentUploader = 'DocumentUploader',
  ParcelPlaces = 'ParcelPlaces',
  SignatureConfirmed = 'SignatureConfirmed',
  InvoiceInformation = 'InvoiceInformation',
}

export const EUCountryInformer: SimpleBannerContent = {
  title: 'Зверніть увагу:',
  text: 'Відповідно до нових правил ЄС, за кожен унікальний код УКТЗЕД з отримувача відправлення стягується збір 3€'
}
